import { c as _c } from "react/compiler-runtime";
import { Col, Container, Row } from "react-bootstrap";
import type { BaseNFT, NFTHistory } from "@/entities/INFT";
import styles from "./Timeline.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { numberWithCommasFromString } from "@/helpers/Helpers";
import TimelineMediaComponent, { MediaType } from "./TimelineMedia";
import { faExternalLinkSquare } from "@fortawesome/free-solid-svg-icons";
interface Props {
  nft: BaseNFT;
  steps: NFTHistory[];
}
export default function Timeline(props) {
  const $ = _c(15);
  const getDateDisplay = _temp;
  let t0;
  if ($[0] !== props.nft) {
    t0 = () => {
      if (props.nft.metadata.animation_details?.format === "HTML") {
        return MediaType.HTML;
      } else {
        if (props.nft.metadata.animation_details?.format === "MP4" || props.nft.metadata.animation_details?.format === "MOV") {
          return MediaType.VIDEO;
        } else {
          return MediaType.IMAGE;
        }
      }
    };
    $[0] = props.nft;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getType = t0;
  const getKeyDisplay = _temp3;
  const isImage = _temp4;
  const isAnimation = _temp5;
  const isUrlKey = _temp6;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function printAttribute(label, value, fullWidth) {
      return <Col sm={12} md={fullWidth ? 12 : 6}><b>{label}:</b>{" "}<div dangerouslySetInnerHTML={{
          __html: numberWithCommasFromString(value).replaceAll("\n", "<br>")
        }} /></Col>;
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const printAttribute = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function printFromToFields(from, to) {
      if (from && to) {
        return <>{printAttribute("From", from)}{printAttribute("To", to)}</>;
      }
      const label_0 = from ? "Removed Value" : "Added Value";
      const nonUndefined = from || to;
      return printAttribute(label_0, nonUndefined, true);
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const printFromToFields = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    const printLink = function printLink(label_1, value_0) {
      return <Col xs={12}><b>{label_1}:</b>{" "}<a href={value_0} target="_blank" rel="noopener noreferrer">{value_0}</a></Col>;
    };
    t3 = function printFromToUrls(from_0, to_0) {
      if (from_0 && to_0) {
        return <>{printLink("From", from_0)}{printLink("To", to_0)}</>;
      }
      const label_2 = from_0 ? "Removed URL" : "Added URL";
      const nonUndefined_0 = from_0 || to_0;
      return printLink(label_2, nonUndefined_0);
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const printFromToUrls = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    const printImage = function printImage(label_3, value_1) {
      return <Col className="d-flex align-items-start flex-column gap-1"><b>{label_3}:</b><TimelineMediaComponent type={MediaType.IMAGE} url={value_1} /></Col>;
    };
    t4 = function printFromToImages(from_1, to_1) {
      if (from_1 && to_1) {
        return <>{printImage("From", from_1)}{printImage("To", to_1)}</>;
      }
      const label_4 = from_1 ? "Removed Image" : "Added Image";
      const nonUndefined_1 = from_1 || to_1;
      return printImage(label_4, nonUndefined_1);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const printFromToImages = t4;
  let t5;
  if ($[6] !== getType) {
    const printAnimation = function printAnimation(label_5, value_2) {
      return <Col className="d-flex align-items-start flex-column gap-1"><b>{label_5}:</b><TimelineMediaComponent type={getType()} url={value_2} /></Col>;
    };
    const printFromToAnimation = function printFromToAnimation(from_2, to_2) {
      if (from_2 && to_2) {
        return <>{printAnimation("From", from_2)}{printAnimation("To", to_2)}</>;
      }
      const label_6 = from_2 ? "Removed Animation" : "Added Animation";
      const nonUndefined_2 = from_2 || to_2;
      return printAnimation(label_6, nonUndefined_2);
    };
    t5 = function printContent(change) {
      let content;
      if (isImage(change.key)) {
        content = printFromToImages(change.from, change.to);
      } else {
        if (isAnimation(change.key)) {
          content = printFromToAnimation(change.from, change.to);
        } else {
          if (isUrlKey(change.key)) {
            content = printFromToUrls(change.from, change.to);
          } else {
            if (change.key.endsWith("(Added)")) {
              content = printAttribute("Value", change.to, true);
            } else {
              if (change.key.endsWith("(Removed)")) {
                content = printAttribute("Value", change.from, true);
              } else {
                content = printFromToFields(change.from, change.to);
              }
            }
          }
        }
      }
      return content;
    };
    $[6] = getType;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const printContent = t5;
  let t6;
  if ($[8] !== printContent || $[9] !== props.steps) {
    let t7;
    if ($[11] !== printContent) {
      t7 = (step, index) => <div key={`timeline-${step.block}`} className={`${styles.timelineContainer} ${index % 2 === 0 ? styles.right : styles.left}`}><div className={styles.content}><h5 className="m-0 mb-3">{`${getDateDisplay(step.transaction_date)} UTC`}</h5><Container className="no-padding"><Row className="pb-1"><Col className="d-flex justify-content-between align-items-center gap-4"><b>{step.description.event}</b><span className="d-flex gap-4"><a href={step.uri} target="_blank" rel="noopener noreferrer" className="d-flex align-items-center justify-content-center gap-2 decoration-none">URI<FontAwesomeIcon icon={faExternalLinkSquare} className={styles.linkIcon} /></a><a href={`https://etherscan.io/tx/${step.transaction_hash}`} target="_blank" rel="noopener noreferrer" className="d-flex align-items-center justify-content-center gap-2 decoration-none">TXN<FontAwesomeIcon icon={faExternalLinkSquare} className={styles.linkIcon} /></a></span></Col></Row>{step.description.changes.length > 0 && <ul className={styles.changesUl}>{step.description.changes.map(change_0 => <li key={`timeline-table-${change_0.key}`}><Row className="pt-3 pb-1"><Col><b>{getKeyDisplay(change_0.key)}</b></Col></Row><Row className="pt-1 pb-3">{printContent(change_0)}</Row></li>)}</ul>}</Container></div></div>;
      $[11] = printContent;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    t6 = props.steps.map(t7);
    $[8] = printContent;
    $[9] = props.steps;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = <div className={styles.timeline}>{t6}</div>;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
}
function _temp6(key_2) {
  return ["animation_url", "image_url"].includes(key_2);
}
function _temp5(key_1) {
  return ["animation"].includes(key_1);
}
function _temp4(key_0) {
  return ["image"].includes(key_0);
}
function _temp3(key) {
  key = key.replaceAll("_", " ");
  key = key.replaceAll("::", " - ");
  key = key.replace(/\b\w/g, _temp2);
  return key;
}
function _temp2(match) {
  return match.toUpperCase();
}
function _temp(date) {
  date = new Date(date);
  return `${date.getUTCFullYear()}/${(date.getUTCMonth() + 1).toString().padStart(2, "0")}/${date.getUTCDate().toString().padStart(2, "0")} - ${date.getUTCHours().toString().padStart(2, "0")}:${date.getUTCMinutes().toString().padStart(2, "0")}`;
}